require('./hireCardOpenDebitView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions

const blockedAccountsAction = require('actions/blockedAccounts');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardOpenDebitActions = require('actions/hireCardOpenDebit');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const profileActions = require('actions/profile');
const shippingAddressAction = require('actions/shippingAddress');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const HireCardOpenDebitStep1 = require('components/hire/cardOpenDebit/hireCardOpenDebitStep1/hireCardOpenDebitStep1');
const HireCardOpenDebitStep2 = require('components/hire/cardOpenDebit/hireCardOpenDebitStep2/hireCardOpenDebitStep2');
const HireCardOpenDebitStep3 = require('components/hire/cardOpenDebit/hireCardOpenDebitStep3/hireCardOpenDebitStep3');
const HireCardOpenDebitStep4 = require('components/hire/cardOpenDebit/hireCardOpenDebitStep4/hireCardOpenDebitStep4');
const HireCardOpenDebitSuccess = require('components/hire/cardOpenDebit/hireCardOpenDebitSuccess/hireCardOpenDebitSuccess');
const HireCardOpenDebitError = require('components/hire/cardOpenDebit/hireCardOpenDebitError/hireCardOpenDebitError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_AUTHORIZED,
    CHECKING_ACCOUNT_CODE,
    DEBIT_CARD_TYPE,
    EURO_TEXT,
    OPEN_DEBIT_STANDARD,
    OPEN_DEBIT_SUBTYPE,
    REDIRECT_URL,
    SECOND_STEP,
    WIZARD_FIRST_STEP
} = require('constants/index');
const { ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES } = require('constants/accounts');
const { R42_TRAVEL_PLUS_OFF_HIRING, WEB_INACTIVE_ACCOUNT_ENABLED, ES_COUNTRY, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

const { HIRE_CARD_OPEN_DEBIT } = require('constants/operationCodesAccounts');
const { catalogue, analyticsId } = require('components/hire/cardOpenDebit/analytics/hireCardOpenDebitAnalytics');

class HireCardOpenDebitView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getHireCardImages,
            getBlockedAccounts,
            immAccounts,
            match: { params: { redirect } },
            validateStep,
            getshippingAddressList,
            resetPrecontractualDocumentMail,
            validateBlockedAccount
        } = this.props;
        validateBlockedAccount()
        resetPrecontractualDocumentMail();
        getHireCardImages([this.getCardImage()]);

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getshippingAddressList();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_OPEN_DEBIT);
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();
        if (__CONTACT_CENTER__) resetPrecontractualMail();
    }

    getProcessDetail() {
        const cardImage = this.getCardImage().split('.');
        return `${cardImage[1]}.${cardImage[2]}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    getCardImage() {
        const { immFlagBasedFeatures, immProfile } = this.props;
        let cardImageIds = {
            default: 'B.506.002.020',
            de: 'B.506.013.012',
            nl: 'B.506.014.017',
            pt: 'B.506.015.012',
        };

        if (immFlagBasedFeatures.get(R42_TRAVEL_PLUS_OFF_HIRING)) {
            cardImageIds.de = 'B.506.013.007';
            cardImageIds.nl = 'B.506.014.017';
            cardImageIds.pt = 'B.506.015.007';
        }

        return cardImageIds[immProfile.get('originCountry').toLowerCase()] || cardImageIds['default'];
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardOpenDebit } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardOpenDebit.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardOpenDebit,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardOpenDebit.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardOpenDebitSuccess
                    immAccount={immAccount}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardOpenDebit={immHireCardOpenDebit}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList}
                    originCountry={immProfile.get('originCountry')}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const immAcountsWithoutDebitCard = this.getAccountsWithoutDebitCard();
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
        ];

        if (__CONTACT_CENTER__) {
            const index = interventionTypes.indexOf(ACCOUNT_INTERVENTION_AUTHORIZED);
            if (index > -1) {
                interventionTypes.splice(index, 1);
            }
        }

        const accountsIndexes = immAcountsWithoutDebitCard.filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    getAccountsWithoutDebitCard() {
        const { immAccounts, immCards } = this.props;
        return immAccounts.get('byOrder').filter(accountId => {
            const accountHasDebit = immCards.getIn(['debit', 'byOrder']).find(cardId => {
                const immCard = immCards.getIn(['byId', cardId]);
                return immCard.get('isOpenDebit') &&
                    immCard.get('status') === 'EN VIGOR' &&
                    (immCard.get('associatedAccountShort') === immAccounts.getIn(['byId', accountId, 'contractNumber']));
            });

            return !accountHasDebit;
        });
    }

    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardOpenDebit,
            hireInformationOpenDebitError,
            hireInformationOpenDebitSuccess,
            immAccounts,
            immContracts,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardOpenDebit,
            immHireInformation,
            immHiringProductInformation,
            immHireContactData,
            immPdfData,
            immPreContractualMail,
            immProfile,
            immShippingAddressList,
            requestPDFMerge,
            requestProfile,
            sendPrecontractualDocumentMail,
            sendPreContractualMail,
            setAllAccountsToInactive,
            setVisibleStep,
            setWillCancel,
            setShippingAddress,
            setTermsAndCondsText,
            validateStep
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardOpenDebit,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardOpenDebit.get('steps');
        const sendMailParams = {
            type: DEBIT_CARD_TYPE,
            subType: OPEN_DEBIT_SUBTYPE,
            standar: OPEN_DEBIT_STANDARD
        };
        let hasShippingAddress = true;
        const gestorCrossEnabled = immFlagBasedFeatures.get('web-gc-enabled');

        const productName = this.getProcessDetail();
        const tealiumData = [
          catalogue[analyticsId.OPEN_DEBIT_CARD_STEP_1_VIEW]({ productName }),
          catalogue[analyticsId.OPEN_DEBIT_CARD_STEP_2_VIEW]({ productName }),
          catalogue[analyticsId.OPEN_DEBIT_CARD_STEP_3_VIEW]({ productName }),
          catalogue[analyticsId.OPEN_DEBIT_CARD_STEP_4_VIEW]({ productName }),
        ];
        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardOpenDebit.get('loadingFlag');
    
        return (
          <div>
            <div className="col-xs-12 col-md-8">
              <Wizard
                actions={wizardActions}
                immSteps={immSteps}
                showPreLeaveModal={showPreLeaveModal}
                stepsAmount={immSteps.size}
                tealium={tealiumData[immHireCardOpenDebit.get('visibleStep') - 1]}
                visibleStep={immHireCardOpenDebit.get('visibleStep')}
                wizardClass="hire-card-open-debit__wizard"
                isTaggingSecondVersion
              >
                        <WizardStep
                            isLoading={loadingFlag}
                            cancelButton={true}
                            position="first"
                        >
                            <WebappRender>
                                <HireCardOpenDebitStep1
                                    flagBasedFeatures={immFlagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    hireCmsKey="opendebit"
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    requestPDFMerge={requestPDFMerge}
                                    contracts={immContracts}
                                />
                            </WebappRender>
                            <ContactCenterRender>
                                <HireCardOpenDebitStep1
                                    contractName="open-debit"
                                    flagBasedFeatures={immFlagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    hireCmsKey="opendebit"
                                    hireInformationOpenDebitError={hireInformationOpenDebitError}
                                    hireInformationOpenDebitSuccess={hireInformationOpenDebitSuccess}
                                    immHireCardOpenDebit={immHireCardOpenDebit}
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    immPreContractualMail={immPreContractualMail}
                                    immProfileFields={immProfile}
                                    requestProfile={requestProfile}
                                    sendMailParams={sendMailParams}
                                    sendPreContractualMail={sendPreContractualMail}
                                    requestPDFMerge={requestPDFMerge}
                                    contracts={immContracts}
                                    setTermsAndCondsText={setTermsAndCondsText}
                                />
                            </ContactCenterRender>
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardOpenDebitStep2
                                accountsIndexesFiltered={this.filterAccounts()}
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardOpenDebit={immHireCardOpenDebit}
                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                                contracts={immContracts}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                            nextButtonDisabled={isShippingAddressButtonDisabled}
                        >
                            <HireCardOpenDebitStep3
                                immHireContactData={immHireContactData}
                                immShippingAddressList={immShippingAddressList}
                                setShippingAddress={setShippingAddress}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hireCardOpenDebit-hire'}
                            isLoading={immHireCardOpenDebit.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <HireCardOpenDebitStep4
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardOpenDebit={immHireCardOpenDebit}
                                immShippingAddress={immShippingAddressList}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                operativeName={__CONTACT_CENTER__ ? "operatives-openDebit" : undefined}
                                originCountry={immProfile.get('originCountry')}
                                immPdfData={immPdfData}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immAddress={immShippingAddressList.get('shippingAddress')}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immProfile={immProfile}
                                immShippingAddressList={immShippingAddressList}
                                selectedAccount={immSteps.getIn([SECOND_STEP, 'accountId'])}
                                type="debit"
                                hasShippingAddress={hasShippingAddress}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardOpenDebit, immFlagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hireCardOpenDebit-pageTitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardOpenDebit-breadcrumb")
            }
        ];
        const isErrorAvailableAccounts = this.filterAccounts().length === 0;

        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardOpenDebit.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const isFetchingBlocked = immHireCardOpenDebit.get('isFetchingBlocked');
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;

        if (immHireCardOpenDebit.get('error') || isErrorAvailableAccounts) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardOpenDebitError
                        immHireCardOpenDebit={immHireCardOpenDebit}
                        isErrorAvailableAccounts={isErrorAvailableAccounts}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardOpenDebitError
                        immHireCardOpenDebit={immHireCardOpenDebit}
                        isErrorAvailableAccounts={isErrorAvailableAccounts}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        }else if(immHireCardOpenDebit.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-open-debit">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {isFetchingBlocked  ? <LoadingSection /> :
                                content
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardOpenDebitView.propTypes = {
    gestorCrossEnabled: PropTypes.bool,
    getBlockedAccounts: PropTypes.func,
    getHireCardImages: PropTypes.func.isRequired,
    getshippingAddressList: PropTypes.func,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardOpenDebit: PropTypes.func.isRequired,
    hireInformationOpenDebitError: PropTypes.func.isRequired,
    hireInformationOpenDebitSuccess: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immContracts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardOpenDebit: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = HireCardOpenDebitView;
module.exports.HireCardOpenDebitView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immContracts: state.globalVariables.getIn(['variables', 'parameters', 'contratos']),
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardOpenDebit: state.hireCardOpenDebit,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immHireContactData: state.hireContactData,
        immPdfData: state.precontractualsMergePdfs,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
    }),
    {
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        handleAccountChange: hireCardOpenDebitActions.setAccount,
        handleAgreementCheckboxChange: hireCardOpenDebitActions.setAgreementCheckbox,
        hireCardOpenDebit: hireCardOpenDebitActions.hireCardOpenDebit,
        hireInformationOpenDebitError: hireCardOpenDebitActions.hireInformationOpenDebitError,
        hireInformationOpenDebitSuccess: hireCardOpenDebitActions.hireInformationOpenDebitSuccess,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        requestProfile: profileActions.requestProfile,
        reset: hireCardOpenDebitActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        setAllAccountsToInactive: hireCardOpenDebitActions.setAllAccountsToInactive,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardOpenDebitActions.setVisibleStep,
        setWillCancel: hireCardOpenDebitActions.setWillCancel,
        validateStep: hireCardOpenDebitActions.validateStep,
        validateBlockedAccount: hireCardOpenDebitActions.validateBlockedAccount
    }
)(withRouter(HireCardOpenDebitView));
